import axios from "axios";
import { devUrl } from "./settings";

const instance = axios.create({
  baseURL: devUrl
});

export default instance;
